import { render, staticRenderFns } from "./AccountingPeriods.vue?vue&type=template&id=c66e3fe4&scoped=true"
import script from "./AccountingPeriods.vue?vue&type=script&lang=js"
export * from "./AccountingPeriods.vue?vue&type=script&lang=js"
import style0 from "./AccountingPeriods.vue?vue&type=style&index=0&id=c66e3fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66e3fe4",
  null
  
)

export default component.exports